// extracted by mini-css-extract-plugin
export default {"TextEditor__Textarea":"TextEditor_TextEditor__Textarea__zGD2s"};